export const CustomSacs =[
	{
		"brand": "fatsac",
		"title": "Custom Sacs",
		"slug": "ballast-semicustom-w507c",
		"category": "wakeboard-semicustom",
		"partNumber": "W507-C",
		"description": "You can special order sacs to suit your needs. We make all of our Fat Sacs in house which gives us the ability to create completely custom sacs for our customers. The same process that is used to build our line of Fat Sacs will be utilized to create your custom sacs. By using our advanced cutting machine, welding system and Valmex material we can assure you that your designed sac will be extremely durable and of the highest quality. You also decide on which type of fittings you would like to use, how many there are and their exact location on the sac. Whether it's a totally customized integrated system you are looking for or just a single sac, contact us, and we will make your design happen.",
		"price": "",
		"image": "Y",
		"boats": []
	},
	{
		"brand": "fatsac",
		"title": "Inboard Rear Wake Kit (all ballast, fittings, and pumps included to fully integrate KIT)",
		"slug": "ballast-semicustom-retro-rear-kit",
		"category": "wakeboard-semicustom",
		"partNumber": "O8005",
		"description": "<ul><li>800 pounds total</li><li>Fits all boats and models that are INBOARDS before 2010</li><li>All ballast, fittings, and pumps included to fully integrate KIT</li></ul>",
		"price": 2202.99,
		"image": "Y",
		"boats": []
	},
	{
		"brand": "fatsac",
		"title": "Inboard Rear & Front Wake Kit (all ballast, fittings, and pumps included to fully integrate KIT)",
		"slug": "ballast-semicustom-v-drive-kit",
		"category": "wakeboard-semicustom",
		"partNumber": "O8006",
		"description": "<ul><li>1,100 pounds total</li><li>Fits all boats and models that are INBOARDS before 2010</li><li>All ballast, fittings, and pumps included to fully integrate KIT</li></ul>",
		"price": 3872.99,
		"image": "Y",
		"boats": []
	},
	{
		"brand": "fatsac",
		"title": "Ultimate Wake Surf Sac",
		"slug": "ballast-semicustom-w718",
		"category": "wakeboard-semicustom",
		"partNumber": "W718",
		"description": "<ul><li>60x24x16</li><li>1150LBS</li><li>Fittings: (1) W730, (4) W731, (1) W749</li></ul>",
		"price": 534.29,
		"image": "Y",
		"onlyShowUnfiltered": true,
		"boats": []
	},
	{
		"brand": "fatsac",
		"title": "Fat Seat  (PATENTED)",
		"slug": "ballast-semicustom-w710",
		"category": "wakeboard-semicustom",
		"partNumber": "W710",
		"description": "<ul><li>Fits inboards with removable rear seat</li><li>Fittings: (1) W730, (4) W731, (1) W749</li></ul>",
		"price": 614.39,
		"image": "Y",
		"onlyShowUnfiltered": true,
		"boats": []
	},
	{
		"brand": "fatsac",
		"title": "Fly High ENZO Fat Sac 1450 LBS",
		"slug": "ballast-semicustom-w712",
		"category": "wakeboard-semicustom",
		"partNumber": "W712",
		"description": "<ul><li>Body 30x25x26 Arm 72x25x12</li><li>Fittings not included</li><li>1450 lbs.</li></ul>",
		"price": 705.59,
		"image": "Y",
		"onlyShowUnfiltered": true,
		"boats": []
	},
	{
		"brand": "fatsac",
		"title": "MALIBU / AXIS PNP REAR SACS, 550 POUNDS EACH, (GETS 3/4\" QC FITTINGS) ",
		"slug": "ballast-semicustom-w025-550-avo",
		"category": "wakeboard-semicustom",
		"partNumber": "W025-550-AVO",
		"description": "<ul><li>3/4\" QC Fittings Included</li><li>550 lbs. each</li></ul>",
		"price": 340.19,
		"image": "",
		"extraImages": ["/images/ballast-semicustom-w025-550-avo.jpg", "/images/ballast-semicustom-w025-550-avo-2.jpg", "/images/ballast-semicustom-w025-550-avo-3.jpg"],
		"boats": [{
				"make": "Axis",
				"model": "T22",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "M235",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "M235",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "M235",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "M235",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "21VLX",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "21VLX",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "21VLX",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "21VLX",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "21MLX",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "21MLX",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "21VLX",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "21MLX",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "21VLX",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "21MLX",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "T220",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "T250",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "A225",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "T235",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "T220",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "T250",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "AXIS PNP REAR SACS, 900 POUNDS EACH, (GETS 3/4\" QC FITTINGS) ",
		"slug": "ballast-semicustom-w025-900-avo",
		"category": "wakeboard-semicustom",
		"partNumber": "W025-900-AVO",
		"description": "<ul><li>3/4\" QC Fittings Included</li><li>900 lbs. each</li></ul>",
		"price": 403.19,
		"image": "",
		"extraImages": ["/images/ballast-semicustom-w025-900-avo.jpg", "/images/ballast-semicustom-w025-900-avo-2.jpg"],
		"boats": [{
				"make": "Axis",
				"model": "A24",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "T250",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "T250",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU & AXIS PNP REAR SACS PORT & STB, RIDING CAPACITY 400 POUNDS EACH, (GETS 3/4\" QC FITTINGS & A PLUG) ",
		"slug": "ballast-semicustom-w025-400-avo",
		"category": "wakeboard-semicustom",
		"partNumber": "W025-400-AVO",
		"description": "<ul><li>3/4\" QC Fittings Included</li><li>400 lbs. each</li></ul>",
		"price": 325.49,
		"image": "",
		"extraImages": ["/images/ballast-semicustom-w025-400-avo.jpg", "/images/ballast-semicustom-w025-400-avo-2.jpg", "/images/ballast-semicustom-w025-400-avo-3.jpg", "/images/ballast-semicustom-w025-400-avo-4.jpg"],
		"boats": [{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "21VLX",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "21MLX",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "21VLX",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "21MLX",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "21VLX",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "21MLX",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "21LX",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "T220",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2023"
			},
			{
				"make": "Malibu",
				"model": "21LX",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2023"
			},{
				"make": "Axis",
				"model": "A225",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "T220",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU PNP REAR SACS PORT & STB, STOCK MOTOR CAPACITY 400 POUNDS EACH, (GETS 1-1/8\" QC FITTINGS & A PLUG)",
		"slug": "ballast-semicustom-w022-400-avo",
		"category": "wakeboard-semicustom",
		"partNumber": "W022-400-AVO",
		"description": "<ul><li>1 1/8\" QC Fittings Included</li><li>400 lbs. each</li></ul>",
		"price": 760.99,
		"image": "Y",
		"boats": [{
			"make": "Malibu",
			"model": "M220",
			"year": "2021"
		},
		{
			"make": "Malibu",
			"model": "M220",
			"year": "2022"
		},
		{
			"make": "Malibu",
			"model": "M220",
			"year": "2023"
		}]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU PNP REAR SACS PORT & STB, STOCK MOTOR CAPACITY 300 POUNDS EACH, (GETS 1-1/8\" QC FITTINGS & A PLUG) ",
		"slug": "ballast-semicustom-w022-300-avo",
		"category": "wakeboard-semicustom",
		"partNumber": "W022-300-AVO",
		"description": "<ul><li>1 1/8\" QC Fittings Included</li><li>300 lbs. each</li></ul>",
		"price": 749.99,
		"image": "",
		"boats": [
		{
			"make": "Malibu",
			"model": "22LSV",
			"year": "2023"
		}]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU PNP REAR SACS, 550 POUNDS EACH, (GETS 1-1/8\" QC FITTINGS) ",
		"slug": "ballast-semicustom-w024-550-avo",
		"category": "wakeboard-semicustom",
		"partNumber": "W024-550-AVO",
		"description": "<ul><li>1 1/8\" QC Fittings Included</li><li>550 lbs. each</li></ul>",
		"price": 398.99,
		"image": "",
		"boats": [{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "22VLX",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "22VLX",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "22VLX",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2017"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU PNP REAR SACS, 750 POUNDS EACH, (GETS 1-1/8\" QC FITTINGS) ",
		"slug": "ballast-semicustom-w024-750-avo",
		"category": "wakeboard-semicustom",
		"partNumber": "W024-750-AVO",
		"description": "<ul><li>1 1/8\" QC Fittings Included</li><li> 750 lbs. each</li></ul>",
		"price": 415.79,
		"image": "",
		"boats": [{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "20VTX",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "22VLX",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "22VLX",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "22VLX",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2017"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU PNP REAR SACS PORT & STB, STANDARD CAPACITY, 570 POUNDS EACH, (GETS 1-1/8\" QC FITTINGS) ",
		"slug": "ballast-semicustom-w022-570-avo",
		"category": "wakeboard-semicustom",
		"partNumber": "W022-570-AVO",
		"description": "<ul><li>1 1/8\" QC Fittings Included</li><li>1140 lbs. total</li></ul>",
		"price": 792.74,
		"image": "",
		"extraImages": ["/images/ballast-semicustom-w022-570-avo.jpg", "/images/ballast-semicustom-w022-570-avo-2.jpg", "/images/ballast-semicustom-w022-570-avo-3.jpg", "/images/ballast-semicustom-w022-570-avo-4.jpg"],
		"boats": [{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "22LSV",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "22LSV",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "23MXZ",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "22LSV",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "23MXZ",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "M220",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "22LSV",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "23MXZ",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "M220",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2023"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2023"
			},
			{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2023"
			},
			{
				"make": "Malibu",
				"model": "23MXZ",
				"year": "2023"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2023"
			},
			{
				"make": "Malibu",
				"model": "M220",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU PNP REAR SACS PORT & STB, MAXIMUM CAPACITY 650 POUNDS EACH, (GETS 1-1/8\" QC FITTINGS) ",
		"slug": "ballast-semicustom-w022-650-avo",
		"category": "wakeboard-semicustom",
		"partNumber": "W022-650-AVO",
		"description": "<ul><li>1 1/8\" QC Fittings Included</li><li>1300 lbs. total</li></ul>",
		"price": 829.49,
		"image": "",
		"extraImages": ["/images/ballast-semicustom-w022-650-avo.jpg", "/images/ballast-semicustom-w022-650-avo-2.jpg", "/images/ballast-semicustom-w022-650-avo-3.jpg", "/images/ballast-semicustom-w022-650-avo-4.jpg"],
		"boats": [{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "22MXZ",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2016"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2017"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "23LSV",
				"year": "2018"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2019"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2020"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2021"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2022"
			},
			{
				"make": "Malibu",
				"model": "25LSV",
				"year": "2023"
			},
			{
				"make": "Malibu",
				"model": "24MXZ",
				"year": "2023"
			},
			{
				"make": "Malibu",
				"model": "26LSV",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "AXIS PNP REAR SACS, 750 POUNDS EACH, (GETS 3/4\" QC FITTINGS) ",
		"slug": "ballast-semicustom-w025-750-avo",
		"category": "wakeboard-semicustom",
		"partNumber": "W025-750-AVO",
		"description": "<ul><li>3/4\" QC Fittings Included</li><li>750 lbs. each</li></ul>",
		"price": 371.69,
		"image": "",
		"extraImages": ["/images/ballast-semicustom-w025-750-avo.jpg", "/images/ballast-semicustom-w025-750-avo-2.jpg", "/images/ballast-semicustom-w025-750-avo-3.jpg", "/images/ballast-semicustom-w025-750-avo-4.jpg"],
		"boats": [{
				"make": "Axis",
				"model": "T22",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "T250",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "T235",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "T250",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "AXIS WAKE PNP BOW SAC, FITS IN BOW, 525 POUNDS, (GETS ALL 1-1/8\" QC FITTINGS)",
		"slug": "ballast-semicustom-w026-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W026-1 1/8",
		"description": "<ul><li>Fittings Included</li><li>525 lbs.</li></ul>",
		"price": 466.19,
		"image": "",
		"extraImages": ["/images/ballast-semicustom-w026-118.jpg", "/images/ballast-semicustom-w026-118-2.jpg", "/images/ballast-semicustom-w026-118-3.jpg", "/images/ballast-semicustom-w026-118-4.jpg"],
		"boats": [{
				"make": "Axis",
				"model": "T22",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2021"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "T220",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "T250",
				"year": "2022"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "A225",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "T220",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "T250",
				"year": "2023"
			},
			{
				"make": "Axis",
				"model": "T350",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "AXIS WAKE PNP BOW SAC, FITS IN BOW, 900 POUNDS, (GETS 4 X W743-SS, 1 X W749 FITTINGS)",
		"slug": "ballast-semicustom-w027-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W027-1 1/8",
		"description": "<ul><li>Fittings Included</li><li>900 Lbs.</li><li>5 threaded valve ports: 4x W743-SS QC fittings, 1x W749 air plug</li></ul>",
		"price": 491.39,
		"image": "",
		"extraImages": ["/images/ballast-semicustom-w027-118.jpg", "/images/ballast-semicustom-w027-118-2.jpg"],
		"boats": [{
				"make": "Axis",
				"model": "A24",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2019"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2020"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2021"
			},
			{
					"make": "Axis",
					"model": "A24",
					"year": "2022"
				},
				{
						"make": "Axis",
						"model": "A24",
						"year": "2023"
					}
		]
	},
	{
		"brand": "fatsac",
		"title": "AXIS WAKE PNP BOW SAC, FITS IN BOW, 325 LBS. (GETS ALL 1-1/8\" QC FITTINGS)",
		"slug": "ballast-semicustom-w0287-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W028-1 1/8",
		"description": "<ul><li>Fits in bow  1 1/8\" (Fittings Included)</li><li>325 Lbs.</li></ul>",
		"price": 453.59,
		"image": "",
		"boats": [{
				"make": "Axis",
				"model": "T22",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2018"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2019"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "AXIS WAKE PNP BOW SAC, 600 POUNDS, (GETS ALL 1-1/8\" QC FITTINGS)",
		"slug": "ballast-semicustom-w029-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W029-1 1/8",
		"description": "<ul><li>Body 35x40x10 Arms 21x18x10</li><li>1 1/8\" Fittings Included</li><li>600 lbs.</li></ul>",
		"price": 478.79,
		"image": "",
		"boats": [{
				"make": "Axis",
				"model": "A24",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2016"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2017"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2018"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "AXIS WAKE PNP REAR SAC, 400 POUNDS, (GETS 1-1/8\" QC FITTINGS)",
		"slug": "ballast-semicustom-w038-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W038-1 1/8",
		"description": "<ul><li>42x16x16</li><li>1 1/8\" Fittings Included</li><li>400 Lbs.</li></ul>",
		"price": 302.39,
		"image": "",
		"boats": [{
				"make": "Axis",
				"model": "T22",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2013"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2013"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2015"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU PNP REAR SAC, 250 POUNDS, (GETS 1-1/8\" QC FITTINGS)",
		"slug": "ballast-semicustom-w039-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W039-1 1/8",
		"description": "<ul><li>38x19.5x9.5</li><li>1 1/8\" Fittings Included</li><li>250LBS</li><li>Fits all Malibu w/ PNP from 2013-2015</li></ul>",
		"price": 340.19,
		"image": "",
		"boats": [{
				"make": "Malibu",
				"model": "",
				"year": "2013"
			},
			{
				"make": "Malibu",
				"model": "",
				"year": "2014"
			},
			{
				"make": "Malibu",
				"model": "",
				"year": "2015"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "AXIS WAKE PNP BOW ARROW SAC, 950 POUNDS",
		"slug": "ballast-semicustom-w031-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W031-1 1/8",
		"description": "<ul><li>Center Locker/Arrow Poing 48x40x8 Arm 32x15x8</li><li>1 1/8\" Fittings Included</li><li>950 lbs.</li><li>Fits 2013 - 2014 Axis A22 Bow, 2013 - 2015 Axis A20 Bow</li></ul>",
		"price": 453.59,
		"image": "",
		"boats": [{
				"make": "Axis",
				"model": "A22",
				"year": "2013"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2013"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2015"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU PNP REAR SAC, 550 POUNDS, (GETS 1-1/8\" QC FITTINGS)",
		"slug": "ballast-semicustom-w034-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W034-1 1/8",
		"description": "<ul><li>37.5x19.5x19</li><li>1 1/8\" Fittings Included</li><li>550 lbs.</li><li>Fits all Malibu w/ PNP from 2013-2015</li></ul>",
		"price": 352.79,
		"image": "",
		"boats": [{
				"make": "Malibu",
				"model": "",
				"year": "2013"
			},
			{
				"make": "Malibu",
				"model": "",
				"year": "2014"
			},
			{
				"make": "Malibu",
				"model": "",
				"year": "2015"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU / AXIS PNP REAR SAC, 1100 POUNDS, (GETS 1-1/8\" FITTINGS)",
		"slug": "ballast-semicustom-w036-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W036-1 1/8",
		"description": "<ul><li>50x24x24</li><li>1 1/8\" Fittings Included</li><li>1100 lbs.</li><li>Fits all Malibu w/ PNP from 2013-2015</li></ul>",
		"price": 371.69,
		"image": "",
		"boats": [{
				"make": "Malibu",
				"model": "",
				"year": "2013"
			},
			{
				"make": "Malibu",
				"model": "",
				"year": "2014"
			},
			{
				"make": "Malibu",
				"model": "",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2013"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2013"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2015"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "MALIBU / AXIS PNP REAR SAC, 750 POUNDS, (GETS 1-1/8\" FITTINGS)",
		"slug": "ballast-semicustom-w037-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W037-1 1/8",
		"description": "<ul><li>50x20x20</li><li>1 1/8\" Fittings Included</li><li>750 lbs.</li><li>Fits all Malibu w/ PNP from 2013-2015</li></ul>",
		"price": 340.19,
		"image": "",
		"boats": [{
				"make": "Malibu",
				"model": "",
				"year": "2013"
			},
			{
				"make": "Malibu",
				"model": "",
				"year": "2014"
			},
			{
				"make": "Malibu",
				"model": "",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "T22",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "T23",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A24",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2013"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2015"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2013"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2014"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2015"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "AXIS WAKE REAR PNP SAC, 400 POUNDS",
		"slug": "ballast-semicustom-w030",
		"category": "wakeboard-semicustom",
		"partNumber": "W030",
		"description": "<ul><li>46x16x16</li><li>400 lbs.</li></ul>",
		"price": 327.59,
		"image": "Y",
		"boats": [{
				"make": "Axis",
				"model": "A20",
				"year": "2010"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2011"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2012"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2010"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2011"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2012"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "AXIS WAKE PNP BOW ARROW SAC, 950 POUNDS",
		"slug": "ballast-semicustom-w031",
		"category": "wakeboard-semicustom",
		"partNumber": "W031",
		"description": "<ul><li>Center Locker/Arrow Poing 48x40x8 Arm 32x15x8</li><li>950 lbs.</li><li>Fits 2010-2012 Axis A20, A22 Bow</li></ul> ",
		"price": 453.59,
		"image": "Y",
		"boats": [{
				"make": "Axis",
				"model": "A20",
				"year": "2010"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2011"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2012"
			},
			{
					"make": "Axis",
					"model": "A22",
					"year": "2010"
				},
				{
					"make": "Axis",
					"model": "A22",
					"year": "2011"
				},
				{
					"make": "Axis",
					"model": "A22",
					"year": "2012"
				}
		]
	},

	{
		"brand": "fatsac",
		"title": "AXIS WAKE PNP REAR SAC, 750 POUNDS",
		"slug": "ballast-semicustom-w032",
		"category": "wakeboard-semicustom",
		"partNumber": "W032",
		"description": "<ul><li>50x20x20</li><li>750 lbs.</li></ul>",
		"price": 340.19,
		"image": "Y",
		"boats": [{
				"make": "Axis",
				"model": "A20",
				"year": "2010"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2011"
			},
			{
				"make": "Axis",
				"model": "A20",
				"year": "2012"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2010"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2011"
			},
			{
				"make": "Axis",
				"model": "A22",
				"year": "2012"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Nautique Wedge Fat Sac (set)",
		"slug": "ballast-semicustom-w708",
		"category": "wakeboard-semicustom",
		"partNumber": "W708",
		"description": "<ul><li>The Nautique Wedge sacs are shaped to fit the compartments of the mid 2000 year model of Nautique V-Drive boats, but can be used in any boat</li><li>42x16x18 400 lbs. (Each)</li><li>Fittings: (2) W730, (4) W731, (2) W749</li></ul>",
		"price": 399.99,
		"image": "Y",
		"boats": [{
			"make": "Nautique",
			"model": "",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Tige 59\" Custom Starboard Surf Sac 800 lbs.",
		"slug": "ballast-semicustom-w004-stb",
		"category": "wakeboard-semicustom",
		"partNumber": "W004-STB",
		"description": "<ul><li>Body 31x24x20 Arm 28x24x9</li><li>800 lbs.</li><li>Fittings not included</li></ul>",
		"price": 454.99,
		"image": "",
		"boats": [{
			"make": "Tige",
			"model": "59\"",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Tige 59\" Custom Portside Surf Sac 800 lbs.",
		"slug": "ballast-semicustom-w004-P",
		"category": "wakeboard-semicustom",
		"partNumber": "W004-P",
		"description": "<ul><li>Body 31x24x20 Arm 28x24x9</li><li>800 lbs.</li><li>Fittings not included</li></ul>",
		"price": 454.99,
		"image": "",
		"boats": [{
			"make": "Tige",
			"model": "59\"",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Tige 84\" Custom Starboard Surf Sac 1000 lbs.",
		"slug": "ballast-semicustom-w005-stb",
		"category": "wakeboard-semicustom",
		"partNumber": "W005-STB",
		"description": "<ul><li>Body 31x24x20 Arm 53x24x9</li><li>1000 lbs.</li><li>Fittings not included</li></ul>",
		"price": 583.99,
		"image": "",
		"boats": [{
			"make": "Tige",
			"model": "84\"",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Tige 84\" Custom Portside Surf Sac 1000 lbs.",
		"slug": "ballast-semicustom-w005-p",
		"category": "wakeboard-semicustom",
		"partNumber": "W005-P",
		"description": "<ul><li>Body 31x24x20 Arm 53x24x9</li><li>1000 lbs.</li><li>Fittings not included</li></ul>",
		"price": 583.99,
		"image": "",
		"boats": [{
			"make": "Tige",
			"model": "84\"",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Mastercraft X-STAR Additional Ballast (4 Sacs) ",
		"slug": "ballast-semicustom-w715",
		"category": "wakeboard-semicustom",
		"partNumber": "W715",
		"description": "<ul><li>2x Custom Rear V-Drive Compartment Sac - 40 x 22 x 22</li><li>2x Custom Front Open Bow Sac (under seats) - 44 x 22 x 6</li><li>Fittings not included</li><li>2500 lbs.</li></ul>",
		"price": 1068.49,
		"image": "Y",
		"boats": [{
			"make": "Mastercraft",
			"model": "X-STAR",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Mastercraft X-STAR Bow Walk-through Fat Sac",
		"slug": "ballast-semicustom-w752",
		"category": "wakeboard-semicustom",
		"partNumber": "W752",
		"description": "<ul><li>Fittings not included</li><li>450 lbs.</li></ul>",
		"price": 311.49,
		"image": "Y",
		"boats": [{
			"make": "Mastercraft",
			"model": "X-STAR",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Mastercraft X-STAR Additional Ballast System 2500 lbs.",
		"slug": "ballast-semicustom-558031",
		"category": "wakeboard-semicustom",
		"partNumber": "558031",
		"description": "<ul><li>2x Custom Rear V-Drive Compartment Sac - 40 x 22 x 22</li><li>2x Custom Front Open Bow Sac (under seats) - 44 x 22 x 6</li><li>3x Custom Distribution Flow Valve</li><li>1x 50' of 1\" Reinforced black bildge hose</li><li>3x Check Valve T-Assembly for venting</li><li>30x hose clamp</li><li>Custom fittings (all preinstalled with PVC cement) 2500 lbs.</li></ul>",
		"price": 1801.79,
		"image": "Y",
		"boats": [{
			"make": "Mastercraft",
			"model": "X-STAR",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Mastercraft X-2 Additional Ballast System 1600 lbs.",
		"slug": "ballast-semicustom-558032",
		"category": "wakeboard-semicustom",
		"partNumber": "558032",
		"description": "<ul><li>2x Custom Rear X-2 Sac</li><li>1x Custom X-2 Integrated Bow Sac (under seats)</li><li>3x Custom Distribution Flow Valve</li><li>1x 50' of 1\" reinforced black bildge hose</li><li>3x Check Valve T-Assembly for venting</li><li>30x Hose clamp</li><li>Custom fittings (all preinstalled with PVC cement)</li></ul>",
		"price": 1801.79,
		"image": "Y",
		"boats": [{
			"make": "Mastercraft",
			"model": "X-2",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Mastercraft X-2 Rear Sac ",
		"slug": "ballast-semicustom-w714",
		"category": "wakeboard-semicustom",
		"partNumber": "W714",
		"description": "<ul><li>Fittings not included</li><li>455 lbs.</li></ul>",
		"price": 286.99,
		"image": "Y",
		"boats": [{
			"make": "Mastercraft",
			"model": "X-2",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Mastercraft X-2 Integrated Bow Sac  ",
		"slug": "ballast-semicustom-w717",
		"category": "wakeboard-semicustom",
		"partNumber": "W717",
		"description": "<ul><li>690 lbs.</li><li>Must not have divider under bow seat</li><li>Fittings not included</li></ul>",
		"price": 494.19,
		"image": "Y",
		"boats": [{
			"make": "Mastercraft",
			"model": "X-2",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Supra SA Plug & Play Rear Sac",
		"slug": "ballast-semicustom-w892-118",
		"category": "wakeboard-semicustom",
		"partNumber": "W892-1 1/8",
		"description": "<ul><li>1 1/8\" Fittings Included</li><li>750 lbs.</li></ul>",
		"price": 627.79,
		"image": "",
		"boats": [{
			"make": "Supra",
			"model": "SA",
			"year": "2010"
		},
		{
			"make": "Supra",
			"model": "SA",
			"year": "2011"
		},
		{
			"make": "Supra",
			"model": "SA",
			"year": "2012"
		},
		{
			"make": "Supra",
			"model": "SA",
			"year": "2013"
		},
		{
			"make": "Supra",
			"model": "SA",
			"year": "2014"
		},
		{
			"make": "Supra",
			"model": "SA",
			"year": "2015"
		},
		{
			"make": "Supra",
			"model": "SA",
			"year": "2016"
		},
		{
			"make": "Supra",
			"model": "SA",
			"year": "2017"
		},
		{
			"make": "Supra",
			"model": "SA",
			"year": "2018"
		},
		{
			"make": "Supra",
			"model": "SA",
			"year": "2019"
		}
	]
	},
	{
		"brand": "fatsac",
		"title": "Rear Gravity Games sac   ",
		"slug": "ballast-semicustom-w841",
		"category": "wakeboard-semicustom",
		"partNumber": "W841",
		"description": "<ul><li>42x19x19</li><li>Fittings not included</li><li>565 lbs.</li></ul>",
		"price": 319.00,
		"image": "Y",
		"boats": [{
				"make": "Supra",
				"model": "",
				"year": ""
			},
			{
				"make": "Moomba",
				"model": "",
				"year": ""
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Center Gravity Games Sac",
		"slug": "ballast-semicustom-w842",
		"category": "wakeboard-semicustom",
		"partNumber": "W842",
		"description": "<ul><li>88x19x19</li><li>Fittings not included</li><li>1180 lbs.</li></ul>",
		"price": 499.99,
		"image": "Y",
		"boats": [{
				"make": "Supra",
				"model": "",
				"year": ""
			},
			{
				"make": "Moomba",
				"model": "",
				"year": ""
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Super Air Nautique Additional Fat Sac Ballast System",
		"slug": "ballast-semicustom-w760",
		"category": "wakeboard-semicustom",
		"partNumber": "W760",
		"description": "<ul><li>1x W709 - Tsunami Pump</li><li>1x W702 - Fat Brick</li><li>1x W741 - fitting</li><li>7x W746 - fittings</li><li>7x W743 - fittings</li><li>1x W701 - V-Drive Fat Sacs (set of 2)</li><li>1x W711 - Integrated Bow Fat Sac 425 lbs.</li></ul>",
		"price": 1632.99,
		"image": "Y",
		"boats": [{
			"make": "Nautique",
			"model": "Super Air",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "Super Air Nautique Center Locker Arrow Sac 650 lbs.",
		"slug": "ballast-semicustom-w721",
		"category": "wakeboard-semicustom",
		"partNumber": "W721",
		"description": "<ul><li>Super Air Nautique Center Locker 650 lbs.</li></ul>",
		"price": 520.89,
		"image": "Y",
		"boats": [{
			"make": "Nautique",
			"model": "Super Air",
			"year": ""
		}]
	},
	{
		"brand": "fatsac",
		"title": "YAMAHA JET BOATS 24' MODEL - 45 X 24 X 34 & FITS SWIM PLATFORM STEP - 4 X HANDLES - 800 LBS. - ALL FITTINGS INCLUDED",
		"slug": "ballast-semicustom-c1039",
		"category": "wakeboard-semicustom",
		"partNumber": "C1039",
		"description": "<ul><li>800 lbs.</li><li>All fittings included</li></ul>",
		"price": 574.29,
		"image": "Y",
		"boats": [{
				"make": "Yamaha",
				"model": "24' MODEL",
				"year": "2017"
			},
			{
				"make": "Yamaha",
				"model": "24' MODEL",
				"year": "2018"
			},
			{
				"make": "Yamaha",
				"model": "24' MODEL",
				"year": "2019"
			},
			{
				"make": "Yamaha",
				"model": "24' MODEL",
				"year": "2020"
			},
			{
				"make": "Yamaha",
				"model": "24' MODEL",
				"year": "2021"
			},
			{
				"make": "Yamaha",
				"model": "24' MODEL",
				"year": "2022"
			},
			{
				"make": "Yamaha",
				"model": "24' MODEL",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "YAMAHA JET BOATS 21' MODEL - 35 X 26 X 32.5 & FITS SWIM PLATFORM STEP - 4 X HANDLES - 725 LBS. - ALL FITTINGS INCLUDED",
		"slug": "ballast-semicustom-c1046",
		"category": "wakeboard-semicustom",
		"partNumber": "C1046",
		"description": "<ul><li>725 lbs.</li><li>All fittings included</li></ul>",
		"price": 547.59,
		"image": "Y",
		"boats": [{
				"make": "Yamaha",
				"model": "21' MODEL",
				"year": "2017"
			},
			{
				"make": "Yamaha",
				"model": "21' MODEL",
				"year": "2018"
			},
			{
				"make": "Yamaha",
				"model": "21' MODEL",
				"year": "2019"
			},
			{
				"make": "Yamaha",
				"model": "21' MODEL",
				"year": "2020"
			},
			{
				"make": "Yamaha",
				"model": "21' MODEL",
				"year": "2021"
			},
			{
				"make": "Yamaha",
				"model": "21' MODEL",
				"year": "2022"
			},
			{
				"make": "Yamaha",
				"model": "21' MODEL",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "YAMAHA JET BOATS 19' MODEL - 35 X 30 X 26 & FITS SWIM PLATFORM STEP - 4 X HANDLES -- 650 LBS. - ALL FITTINGS INCLUDED",
		"slug": "ballast-semicustom-c1062",
		"category": "wakeboard-semicustom",
		"partNumber": "C1062",
		"description": "<ul><li>650 lbs.</li><li>All fittings included</li></ul>",
		"price": 567.69,
		"image": "Y",
		"boats": [{
				"make": "Yamaha",
				"model": "19' MODEL",
				"year": "2017"
			},
			{
				"make": "Yamaha",
				"model": "19' MODEL",
				"year": "2018"
			},
			{
				"make": "Yamaha",
				"model": "19' MODEL",
				"year": "2019"
			},
			{
				"make": "Yamaha",
				"model": "19' MODEL",
				"year": "2020"
			},
			{
				"make": "Yamaha",
				"model": "19' MODEL",
				"year": "2021"
			},
			{
				"make": "Yamaha",
				"model": "19' MODEL",
				"year": "2022"
			},
			{
				"make": "Yamaha",
				"model": "19' MODEL",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Yamaha 25' Model Swim-Deck Sac 850 pounds - ALL FITTINGS INCLUDED",
		"slug": "ballast-semicustom-c1304",
		"category": "wakeboard-semicustom",
		"partNumber": "C1304",
		"description": "<ul><li>850 lbs.</li><li>All fittings included</li></ul>",
		"price": 585.49,
		"image": "Y",
		"boats": [{
				"make": "Yamaha",
				"model": "25' MODEL",
				"year": "2022"
			},
			{
					"make": "Yamaha",
					"model": "25' MODEL",
					"year": "2023"
				}
		]
	},
	{
		"brand": "fatsac",
		"title": "Yamaha 27' Model SwimDeck Bag, 1200 lbs. - ALL FITTINGS INCLUDED",
		"slug": "ballast-semicustom-c1326",
		"category": "wakeboard-semicustom",
		"partNumber": "C1326",
		"description": "<ul><li>1200 lbs.</li><li>All fittings included</li></ul>",
		"price": 593.59,
		"image": "Y",
		"boats": [{
				"make": "Yamaha",
				"model": "25' MODEL",
				"year": "2022"
			},
			{
					"make": "Yamaha",
					"model": "25' MODEL",
					"year": "2023"
				}
		]
	},

	{
		"brand": "fatsac",
		"title": "Tige PNP rear FatSac kit RZX3",
		"slug": "ballast-semicustom-w502",
		"category": "wakeboard-semicustom",
		"partNumber": "W502",
		"description": "<ul><li>Includes Rear Port & STB sacs W/ hose extensions and 1-1/8\" QC fittings</li></ul>",
		"price": 755.99,
		"image": "Y",
		"boats": [{
				"make": "Tige",
				"model": "RZX3",
				"year": "2016"
			},
			{
				"make": "Tige",
				"model": "RZX3",
				"year": "2017"
			},
			{
				"make": "Tige",
				"model": "RZX3",
				"year": "2018"
			},
			{
				"make": "Tige",
				"model": "RZX3",
				"year": "2019"
			},
			{
				"make": "Tige",
				"model": "RZX3",
				"year": "2020"
			},
			{
				"make": "Tige",
				"model": "RZX3",
				"year": "2021"
			},
			{
				"make": "Tige",
				"model": "RZX3",
				"year": "2022"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Tige PNP rear FatSac kit RZX2",
		"slug": "ballast-semicustom-w503",
		"category": "wakeboard-semicustom",
		"partNumber": "W503",
		"description": "<ul><li>Includes Rear Port & STB sacs W/ hose extensions and 1-1/8\" QC fittings</li></ul>",
		"price": 787.49,
		"image": "Y",
		"boats": [{
				"make": "Tige",
				"model": "RZX2",
				"year": "2016"
			},
			{
				"make": "Tige",
				"model": "RZX2",
				"year": "2017"
			},
			{
				"make": "Tige",
				"model": "RZX2",
				"year": "2018"
			},
			{
				"make": "Tige",
				"model": "RZX2",
				"year": "2019"
			},
			{
				"make": "Tige",
				"model": "RZX2",
				"year": "2020"
			},
			{
				"make": "Tige",
				"model": "RZX2",
				"year": "2021"
			},
			{
				"make": "Tige",
				"model": "RZX2",
				"year": "2022"
			}
		]
	}, {
		"brand": "fatsac",
		"title": "Universal Tige PNP FatSac kit",
		"slug": "ballast-semicustom-o5007",
		"category": "wakeboard-semicustom",
		"partNumber": "O5007",
		"description": "<ul><li>Includes PNP fittings 1-1/8\" QC</li><li>ATX, ZX1, RZX2, RZX3, ZX5, Z1</li><li>NO Hose Extensions</li></ul>",
		"price": 492.99,
		"image": "Y",
		"boats": [{
				"make": "Tige",
				"model": "",
				"year": "2016"
			},
			{
				"make": "Tige",
				"model": "",
				"year": "2017"
			},
			{
				"make": "Tige",
				"model": "",
				"year": "2018"
			},
			{
				"make": "Tige",
				"model": "",
				"year": "2019"
			},
			{
				"make": "Tige",
				"model": "",
				"year": "2020"
			},
			{
				"make": "Tige",
				"model": "",
				"year": "2021"
			},
			{
				"make": "Tige",
				"model": "",
				"year": "2022"
			},
			{
				"make": "Tige",
				"model": "",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Nautique 2800lb. Upgrade ballast system",
		"slug": "ballast-semicustom-w761",
		"category": "wakeboard-semicustom",
		"partNumber": "W761",
		"description": "<ul><li>All parts included for auto fill installation</li></ul>",
		"price": 1835.39,
		"image": "",
		"boats": [{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2010"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2011"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2012"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2013"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2014"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2015"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2016"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2017"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2018"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2019"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2020"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2021"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2022"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Nautique 2100lb. Upgrade ballast system",
		"slug": "ballast-semicustom-w762",
		"category": "wakeboard-semicustom",
		"partNumber": "W762",
		"description": "<ul><li>All parts included for auto fill installation</li></ul>",
		"price": 1743.39,
		"image": "",
		"boats": [{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2010"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2011"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2012"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2013"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2014"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2015"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2016"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2017"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2018"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2019"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2020"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2021"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2022"
			},
			{
				"make": "Nautique",
				"model": "Super Air",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Nautique upgrade 900lb. PNP rear bag",
		"slug": "ballast-semicustom-o1700pnp",
		"category": "wakeboard-semicustom",
		"partNumber": "O1700-pnp",
		"description": "<ul><li>Sacs sold individually</li><li>Includes 1\" barbed suction stop fittings</li></ul>",
		"price": 347.29,
		"image": "Y",
		"boats": [{
				"make": "Nautique",
				"model": "GS24",
				"year": "2020"
			},
			{
				"make": "Nautique",
				"model": "G23",
				"year": "2020"
			},
			{
				"make": "Nautique",
				"model": "G25",
				"year": "2020"
			},
			{
				"make": "Nautique",
				"model": "GS24",
				"year": "2021"
			},
			{
				"make": "Nautique",
				"model": "G23",
				"year": "2021"
			},
			{
				"make": "Nautique",
				"model": "G25",
				"year": "2021"
			},
			{
				"make": "Nautique",
				"model": "GS24",
				"year": "2022"
			},
			{
				"make": "Nautique",
				"model": "G23",
				"year": "2022"
			},
			{
				"make": "Nautique",
				"model": "G25",
				"year": "2022"
			},
			{
				"make": "Nautique",
				"model": "GS24",
				"year": "2023"
			},
			{
				"make": "Nautique",
				"model": "G23",
				"year": "2023"
			},
			{
				"make": "Nautique",
				"model": "G25",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Nautique upgrade 600lb. PNP rear bag",
		"slug": "ballast-semicustom-o1701pnp",
		"category": "wakeboard-semicustom",
		"partNumber": "O1701-pnp",
		"description": "<ul><li>Sacs sold individually</li><li>Includes 1\" barbed suction stop fittings</li></ul>",
		"price": 320.59,
		"image": "Y",
		"boats": [{
				"make": "Nautique",
				"model": "G21",
				"year": "2020"
			},
			{
				"make": "Nautique",
				"model": "GS20",
				"year": "2020"
			},
			{
				"make": "Nautique",
				"model": "230",
				"year": "2020"
			},
			{
				"make": "Nautique",
				"model": "G21",
				"year": "2021"
			},
			{
				"make": "Nautique",
				"model": "GS20",
				"year": "2021"
			},
			{
				"make": "Nautique",
				"model": "GS22",
				"year": "2021"
			},
			{
				"make": "Nautique",
				"model": "230",
				"year": "2021"
			},
			{
				"make": "Nautique",
				"model": "G21",
				"year": "2022"
			},
			{
				"make": "Nautique",
				"model": "GS20",
				"year": "2022"
			},
			{
				"make": "Nautique",
				"model": "GS22",
				"year": "2022"
			},
			{
				"make": "Nautique",
				"model": "230",
				"year": "2022"
			},
			{
				"make": "Nautique",
				"model": "G21",
				"year": "2023"
			},
			{
				"make": "Nautique",
				"model": "GS20",
				"year": "2023"
			},
			{
				"make": "Nautique",
				"model": "GS22",
				"year": "2023"
			},
			{
				"make": "Nautique",
				"model": "230",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "MASTERCRAFT Universal Rear PNP Sac / 450 pounds each",
		"slug": "ballast-semicustom-o8700pnp",
		"category": "wakeboard-semicustom",
		"partNumber": "O8700-pnp",
		"description": "<ul><li>Fits all X Series and NXT series</li><li>450 pounds each</li></ul>",
		"price": 320.59,
		"image": "Y",
		"boats": [{
				"make": "Mastercraft",
				"model": "X-Series",
				"year": "2020"
			},
			{
				"make": "Mastercraft",
				"model": "NXT Series",
				"year": "2020"
			},
			{
				"make": "Mastercraft",
				"model": "X-Series",
				"year": "2021"
			},
			{
				"make": "Mastercraft",
				"model": "NXT Series",
				"year": "2021"
			},
			{
				"make": "Mastercraft",
				"model": "X-Series",
				"year": "2022"
			},
			{
				"make": "Mastercraft",
				"model": "NXT Series",
				"year": "2022"
			},
			{
				"make": "Mastercraft",
				"model": "X-Series",
				"year": "2023"
			},
			{
				"make": "Mastercraft",
				"model": "NXT Series",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Skier's Choice Rear PNP bag",
		"slug": "ballast-semicustom-c1227",
		"category": "wakeboard-semicustom",
		"partNumber": "C1227",
		"description": "<ul><li>Black and all Fittings included</li><li>5 plugs, 3 QC 1-1/8\"</li></ul>",
		"price": 427.39,
		"image": "Y",
		"boats": [{
			"make": "Skier's Choice",
			"model": "Makai",
			"year": "2020"
			},
			{
				"make": "Skier's Choice",
				"model": "Kaiyen",
				"year": "2020"
			},
			{
				"make": "Skier's Choice",
				"model": "Makai",
				"year": "2021"
			},
			{
				"make": "Skier's Choice",
				"model": "Kaiyen",
				"year": "2021"
			},
			{
				"make": "Skier's Choice",
				"model": "Makai",
				"year": "2022"
			},
			{
				"make": "Skier's Choice",
				"model": "Kaiyen",
				"year": "2022"
			},
			{
				"make": "Skier's Choice",
				"model": "Makai",
				"year": "2023"
			},
			{
				"make": "Skier's Choice",
				"model": "Kaiyen",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Skier's Choice Rear PNP upgraded Moomba Kaiyen Ballast",
		"slug": "ballast-semicustom-c1259",
		"category": "wakeboard-semicustom",
		"partNumber": "C1259",
		"description": "<ul><li>Upgraded Moomba Kaiyen Ballast</li></ul>",
		"price": 498.99,
		"image": "Y",
		"boats": [{
			"make": "Moomba",
			"model": "Kaiyen",
			"year": "2020"
			},
			{
				"make": "Moomba",
				"model": "Kaiyen",
				"year": "2021"
			},
			{
				"make": "Moomba",
				"model": "Kaiyen",
				"year": "2022"
			},
			{
				"make": "Moomba",
				"model": "Kaiyen",
				"year": "2023"
			}
		]
	},
	{
		"brand": "fatsac",
		"title": "Centurion Ri257 Rear FatSac kit 1400 pounds",
		"slug": "ballast-semicustom-w185",
		"category": "wakeboard-semicustom",
		"partNumber": "W185",
		"description": "<ul><li>Comes with 1 Port and 1 STB and ALL fittings for PNP</li></ul>",
		"price": 599.99,
		"image": "Y",
		"boats": [{
				"make": "Centurion",
				"model": "Ri257",
				"year": "2020"
			},
			{
				"make": "Centurion",
				"model": "Ri257",
				"year": "2021"
			},
			{
				"make": "Centurion",
				"model": "Ri257",
				"year": "2022"
			},
			{
				"make": "Centurion",
				"model": "Ri257",
				"year": "2023"
			}
		]
	}
]
